import {
    ISetSelectedUomAction,
    setSelectedUom,
    ISetUomStateAction,
    setUomState
} from "../actions/tagRequestActions";
import {IUomState, TagRequestActions} from "../types";

const initialState: IUomState = {
    selectedUom: null,
};

export default function(state: IUomState = initialState,  action: ISetSelectedUomAction): IUomState {
    switch (action.type) {
        case TagRequestActions.SetSelectedUom:             return setSelectedUom(state, action as ISetSelectedUomAction);
        case TagRequestActions.SetUomState:                return setUomState(state, action as ISetUomStateAction);
        default:
            return state as IUomState;
    }
}
